module.exports = "//\n// Values\n//\nBiwaScheme.Values = BiwaScheme.Class.create({\n  initialize: function(values){\n    this.content = values;\n  },\n  to_write: function(){\n    return \"#<Values \" +\n             _.map(this.content, BiwaScheme.to_write).join(\" \") +\n           \">\";\n  }\n});\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/biwascheme/src/system/values.js
// module id = 47
// module chunks = 0